export default {
  methods: {
    transformOptions(options) {
      // https://stackoverflow.com/questions/57055428/how-to-display-multiple-labels-in-vue-select-field-using-vue-select-library

      // itemData is our fake property to search data
      return options.map((option) => {
        option.itemData = `${option.name || ''} ${option.email} ${option.phone || ''}`
        return option
      })
    }
  }
}
